import { Component, computed, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { FileResponse } from '@app/models/shared.models';
import { ImgGalleryComponent } from '@app/ui-components/img-gallery/img-gallery.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-gallery',
  imports: [TranslatePipe, ImgGalleryComponent],
  templateUrl: './project-details-gallery.component.html',
  styleUrl: './project-details-gallery.component.scss',
})
export class ProjectDetailsGalleryComponent {
  readonly projectDetails = input.required<ProjectPublicResponse>();

  readonly perRow: number = 4;

  readonly images = computed<FileResponse[]>(() => {
    const project = this.projectDetails();
    const files = project.files ?? [];
    return files.filter((file) => file.contentType?.includes('image'));
  });
}
